import React from "react";
import { Line } from "react-chartjs-2";
import { Chart as chartjs } from "chart.js/auto";
import { convertDate } from "../../../functions/convertDate";
import { convertNumber } from "../../../functions/convertNumbers";

// function LineChart({chartData, priceType ,multiAxis}) {

//     const options = {
//         plugins: {
//             legend: {
//                 display: multiAxis ? true : false,
//             },
//         },
//         responsive:true,
//         interaction:{
//             mode:"index",
//             intersect:false,
//         },
//         scales: {
//             crypto1: {
//                 type: "linear",
//                 display: true,
//                 position: "left",
//                 ticks: {
//                     // Include a dollar sign in the ticks
//                     callback: function(value, index) {
//                         if(priceType=="prices"){
//                             return '$' + value.toLocaleString();
//                         }
//                         else{
//                             return "$" + convertNumber(value);
//                         }

//                     },
//                 },
//             },
//             crypto2: {
//                 type: "linear",
//                 display: true,
//                 position: "right",
//                 ticks: {
//                     // Include a dollar sign in the ticks
//                     callback: function(value, index) {
//                         if(priceType=="prices"){
//                             return '$' + value.toLocaleString();
//                         }
//                         else{
//                             return "$" + convertNumber(value);
//                         }

//                     },
//                 },
//             },
//         },
//     };
//     return <Line data={chartData} options={options} />;
// }

// export default LineChart;

// import React from "react";
// import { Line } from "react-chartjs-2";
// import { Chart as ChartJS } from "chart.js/auto"; //Dont get rid of this

function LineChart({ chartData, priceType, multiAxis }) {
  const options = {
    plugins: {
      legend: {
        display: multiAxis ? true : false,
      },
    },
    responsive: true,
    interaction: {
      mode: "index",
      intersect: false,
    },
    scales: {
      crypto1: {
        position: "left",
        ticks: {
          // Include a dollar sign in the ticks
          callback: function (value, index) {
            if (priceType == "prices") {
              return "$" + value.toLocaleString();
            } else {
              return "$" + convertNumber(value);
            }
          },
        },
      },
      crypto2: multiAxis && {
        position: "right",
        ticks: {
            // Include a dollar sign in the ticks
            callback: function (value, index) {
              if (priceType == "prices") {
                return "$" + value.toLocaleString();
              } else {
                return "$" + convertNumber(value);
              }
            },
          },
       
      },
    },
  };

  return <Line data={chartData} options={options} />;
}

export default LineChart;
